import StudentService from "../services/student-service";


export default class StudentStorage {
  static #storageKey = 'students_list';

  static async update() {
    let response = await StudentService.all();
    sessionStorage.setItem(this.#storageKey, JSON.stringify(response));
  }

  static get() {
    JSON.parse(sessionStorage.getItem(this.#storageKey));
  }
}